import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import PatientAvatar from '../patients/PatientAvatar';
import {formatPatientName} from '../../helpers/patients';

const SchedulerPatientInfo = ({patient = null} = {}) => {
  if (!patient) return null;
  return (
    <Box paddingBottom={2}>
      <Stack direction='row' spacing={2} alignItems='center'>
        <PatientAvatar patient={patient} />
        <Typography variant='subtitle1'>
          {formatPatientName(patient)}
        </Typography>
      </Stack>
    </Box>
  );
};

export default SchedulerPatientInfo;